import { render, staticRenderFns } from "./Meeting-delete.vue?vue&type=template&id=06d5f1d6"
import script from "./Meeting-delete.vue?vue&type=script&lang=js"
export * from "./Meeting-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports